<template>
    <div class="personalMain">
        <p class="current">当前位置：<span>分销人员</span></p>
        <div class="integral-box">
            <Menu></Menu>
            <div class="MainInfo-inte">
                <p class="currTitle">分销统计</p>
                <div class="teams-box">
                    <div>
                        
                        <span>邀请供应商</span>
                        <p>{{ salesmanData.sub_company_amount }}</p>
                    </div>
                    <div>
                        <span>邀请会员</span>
                        <p>{{ salesmanData.sub_company_order_total }}</p>
                    </div>
                    <div>
                        <span>供应商销售数据</span>
                        <p>{{ salesmanData.sub_user_amount }}</p>
                    </div>
                    <div>
                        <span>会员购买数据</span>
                        <p>{{ salesmanData.sub_user_order_total }}</p>
                    </div>
                   
                </div>
            </div>
      
         
        </div>
    </div>
</template>

<script>
import Menu from './index.vue'
export default{
    data(){
        return{
            total: 0,
            salesmanData: {},
            TeamsList: [],
            widthNew: false
        }
    },
    components:{
        Menu
    },
    methods: {
       
        getDateTime(timeDate){
            const year = timeDate.getFullYear();
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0');
            const day = timeDate.getDate().toString().padStart(2, '0');
            const hours = timeDate.getHours().toString().padStart(2, '0');
            const minutes = timeDate.getMinutes().toString().padStart(2, '0');
            const seconds = timeDate.getSeconds().toString().padStart(2, '0');
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

            return formattedDate
        },
    },  
    mounted(){
        
        let data = {}
        this.$store.dispatch('personal/getSalesmanStat',data)
            .then(res => {
                if(res.ok){
                  this.salesmanData = res.data

                }
            })
        
       
    },
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        localStorage.setItem('active','2-12')
    }
}
</script>


<style scoped lang="scss">
.MainInfo-inte{
    width: 910px;min-height: 700px;
    padding: 20px 20px;
    background: #fff;
    .teams-box{
        padding: 0 100px 15px 100px;
        // border-bottom: 0.5px solid #f2f2f2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        margin-top: 20px;
        div{
            text-align: center;
            p{
                font-size: 28px;
                font-weight: 700;
                margin-top: 15px;
            }
            span{
                font-size: 16px;
                color: #666666;
            }
        }
    }
    
}


.currTitle{
    padding: 10px 10px;
    font-size: 22px;
    font-weight: 700px;
    border-bottom: 0.5px solid #f2f2f2;
}

@media screen and (min-width: 541px) {
    .integral-box{
        width: 1200px;
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
    }
}
@media screen and (max-width: 540px) {
    .integral-box{
        width: 96%;
        margin: 15px auto;
    }
    .MainInfo-inte{
        width: 100%;
        padding: 20px 0px;
    }
    .currTitle{
        padding: 5px 10px;
        font-size: 20px;
        
    }

    .teams-box{
        padding-left: 0px;
        font-size: 20px;
    }
    .teams-box div{
        margin: 0px 50px;
    }
    .teams-box p{
        font-size: 26px;
    }
    .teams-box span{
        font-size: 14px;
        color: #666666;
    }
    
    .teams-Item{
        padding-left: 0px;
        font-size: 20px;
    }

}
</style>